<table *ngIf='showTable ; else errorTextField' mat-table [dataSource]="tableData" class="details-screen-table">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef class="volmacht-column"> Naam </th>
    <td mat-cell *matCellDef="let data"> <a (click)="formUrl(data.involvedPartyCode, data.siebelId)" class="volmacht-table-link"> {{data.name ? data.name : emptyValuePlaceholder}} </a></td>
  </ng-container>

  <ng-container matColumnDef="involvedPartyCode">
    <th mat-header-cell *matHeaderCellDef> Type </th>
    <td mat-cell *matCellDef="let data"> {{data.involvedPartyCode ? data.involvedPartyCode : emptyValuePlaceholder}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
</table>
<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
